"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function ChoicesList(_ref) {
  let {
    children
  } = _ref;
  if (children === null) return /*#__PURE__*/_react.default.createElement("ul", null);
  return /*#__PURE__*/_react.default.createElement("ul", null, children.length && children.map(child => {
    return child;
  }));
}
var _default = exports.default = ChoicesList;